import axios from '../plugins/axios'

export default {
  data() {
    return {
      loading: false,
      success: false,
      messageType: 'error',

      email: '',
      password: '',
    }
  },
  methods: {
    login () {
      if (this.loading) {
        return
      }

      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false
          return
        }

        this.submit()
      })
    },

    submit () {
      const formData = new FormData(this.$el)

      this.loading = true
      this.errors.clear()

      axios.post('', formData)
        .then(response => {
          location.href = response.data.data.redirect
        })
        .catch(error => {
          this.loading = false
          this.errors.add({ msg: error.response.data.data.message })
        })
    },
  },
}


// WEBPACK FOOTER //
// ./src/controllers/login.js